export default {
  name: 'mypage',
  data: function () {
    return {
      currentPassword: '',
      password: '',
      passwordConfirmation: '',
      updateSuccess: null,
      updateError: null,
      canValidate: true
    }
  },
  created () {
    this.$store.dispatch('CLEAR_AUTH_STATUS')
    this.updateSuccess = null
    this.updateError = null
  },
  computed: {
    error () {
      if (this.$store.getters.authStatus === 'error') {
        this.updateError = this.$store.getters.authError || this.$store.getters.apiError
      } else {
        this.updateError = null
      }
      return this.updateError
    },
    loginId () {
      return this.$store.getters.userLoginId
    },
    name () {
      return this.$store.getters.userName
    },
    success() {
      if (this.$store.getters.authStatus === 'success') {
        this.updateSuccess = this.$t('Update Successful')
      } else {
        this.updateSuccess = null
      }
      return this.updateSuccess
    },
    validation: function() {
      var v = {
        not_input: !!this.currentPassword && !!this.password && !!this.passwordConfirmation && this.password == this.passwordConfirmation,
        password: this.password == this.passwordConfirmation
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  methods: {
    changePassword: function() {
      this.updateSuccess = null
      this.updateError = null
      this.canValidate = true
      if (this.isValid) {
        var formData = new FormData();
        formData.append('auth_user[current_password]', this.currentPassword);
        formData.append('auth_user[password]', this.password);
        formData.append('auth_user[password_confirmation]', this.passwordConfirmation);
        this.$store.dispatch('CHANGE_PASSWORD', {data: formData})
      } else {
        console.log("need edit")
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/mypage.js